import PeopleIcon from "@mui/icons-material/People";
import BusinessIcon from "@mui/icons-material/Business";
import PublicIcon from "@mui/icons-material/Public";
import AccountTreeIcon from "@mui/icons-material/AccountTree";
import AdminPanelSettingsIcon from "@mui/icons-material/AdminPanelSettings";
import UploadFileIcon from "@mui/icons-material/UploadFile";
import HealthAndSafetyIcon from "@mui/icons-material/HealthAndSafety";
import DashboardIcon from "@mui/icons-material/Dashboard";
import ManageAccountsIcon from "@mui/icons-material/ManageAccounts";
import { SvgIconComponent } from "@mui/icons-material";

export interface NavItem {
  label: string;
  path: string;
  icon: SvgIconComponent;
}

export interface ProductNav {
  productId: string;
  label: string;
  basePath: string;
  items: NavItem[];
  /** Only shown to super_user admins. */
  requiresSuperUser?: boolean;
}

export const navigationConfig: ProductNav[] = [
  {
    productId: "mosaic",
    label: "Mosaic",
    basePath: "/mosaic",
    items: [
      { label: "Users", path: "/mosaic/users", icon: PeopleIcon },
      { label: "Companies", path: "/mosaic/companies", icon: BusinessIcon },
      { label: "Countries", path: "/mosaic/countries", icon: PublicIcon },
      { label: "Departments", path: "/mosaic/departments", icon: AccountTreeIcon },
      { label: "Roles", path: "/mosaic/roles", icon: AdminPanelSettingsIcon },
      { label: "Uploads", path: "/mosaic/uploads", icon: UploadFileIcon },
      { label: "Health Area", path: "/mosaic/health-area", icon: HealthAndSafetyIcon },
    ],
  },
  {
    productId: "derin",
    label: "Derin",
    basePath: "/derin",
    items: [
      { label: "Admin Controls", path: "/derin/admin", icon: DashboardIcon },
    ],
  },
  {
    productId: "surgo",
    label: "Surgo",
    basePath: "/surgo",
    requiresSuperUser: true,
    items: [
      { label: "Admin users", path: "/surgo/admin-users", icon: ManageAccountsIcon },
    ],
  },
];
